webpackJsonp([33781710060979],{

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Reference = function Reference(_ref) {
	  var image = _ref.image,
	      name = _ref.name,
	      additionalClass = _ref.additionalClass;
	  return _react2.default.createElement(
	    'div',
	    { className: additionalClass + ' align-self-center w-100' },
	    _react2.default.createElement('img', { src: image, className: 'img-fluid', alt: name })
	  );
	};
	
	exports.default = Reference;
	module.exports = exports['default'];

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/container-ship.f6efbcea.svg";

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/undraw_browser_stats_704t.a4e45969.svg";

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/undraw_building_blocks_n0nc.0e49379a.svg";

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/undraw_choose_80qg.38b2be3c.svg";

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactstrap = __webpack_require__(13);
	
	var _reference = __webpack_require__(43);
	
	var _reference2 = _interopRequireDefault(_reference);
	
	var _containerShip = __webpack_require__(486);
	
	var _containerShip2 = _interopRequireDefault(_containerShip);
	
	var _undraw_browser_stats_704t = __webpack_require__(138);
	
	var _undraw_browser_stats_704t2 = _interopRequireDefault(_undraw_browser_stats_704t);
	
	var _undraw_building_blocks_n0nc = __webpack_require__(487);
	
	var _undraw_building_blocks_n0nc2 = _interopRequireDefault(_undraw_building_blocks_n0nc);
	
	var _undraw_choose_80qg = __webpack_require__(488);
	
	var _undraw_choose_80qg2 = _interopRequireDefault(_undraw_choose_80qg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeistungenPage = function LeistungenPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Webseiten, Webapplikationen und Anwendungssoftware aus Ober\xF6sterreich',
	      meta: [{ name: 'description', content: 'Webseiten, Webapplikationen, Anwendungssoftware, Cloud-Anwendungen und mehr. Von der Idee zur Lösung.' }, { name: 'keywords', content: 'homepage, webseite, website, cloud, software, webapplikation, anwendungssoftware, automatisierung' }]
	    }),
	    _react2.default.createElement(
	      'section',
	      { className: 'bg evelope' },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { className: 'align-items-center py-5 py-md-7 py-lg-8' },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { md: '6', className: 'order-12 order-md-1' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Leistungen.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'lead my-5' },
	              'Eine gute Idee alleine reicht leider nicht. Ihre Idee soll auch auf einem soliden Fundament aufgebaut sein und ich unterst\xFCtze Sie dabei.'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { md: '6', className: 'order-1 order-md-12' },
	            _react2.default.createElement('img', { src: _undraw_building_blocks_n0nc2.default, className: 'img-fluid p-5 p-md-0', alt: 'Leistungen' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'py-4 py-5' },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { className: 'text-lg-center' },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { className: 'py-4 py-lg-7', lg: '4' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'text-uppercase' },
	              'Webapplikationen'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-4 lead' },
	              'Ma\xDFgeschneiderten Webapplikationen nach Ihren Anforderungen. Ein E-Commerce System mit der Ihre Kunden rund um die Uhr Ihre Produkte kaufen k\xF6nnen. Oder eine Web-Plattform mit der Sie bestimmte Prozesse vereinfachen bzw. automatisieren.'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { className: 'py-4 py-lg-7', lg: '4' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'text-uppercase' },
	              'Webseiten'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-4 lead' },
	              '\xDCberzeugen Sie Ihre Kunden rund um die Uhr mit einem professionellen Online-Auftritt. Aktualisieren Sie Ihre Seiten jederzeit selbstst\xE4ndig, ganz unkompliziert.'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { className: 'py-4 py-lg-7', lg: '4' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'text-uppercase' },
	              'Anwendungssoftware'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'mt-4 lead' },
	              'Wiederkehrende Prozesse von einer Software erledigen lassen - mit weniger Fehlern und erh\xF6hter Effizienz. Wir suchen gemeinsam nach der optimalen L\xF6sung f\xFCr die Automatisierung Ihrer Prozesse - samt Implementierung und Wartung.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'bg radient border-top border-bottom' },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { className: 'py-7' },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { lg: '9' },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'Moderne Technologien.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'lead mt-5' },
	                  'Jedes Projekt hat unterschiedliche Anforderungen. Damit Ihr Projekt auf soliden Beinen steht ist es wichtig zu Beginn die optimale Technologie entsprechend Ihren Anforderungen auszuw\xE4hlen. Falls Sie sich f\xFCr technische Details interessieren, hier ein Auszug meiner bevorzugten Technologien.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: '6', lg: '3', className: 'mt-5' },
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'text-uppercase' },
	                  'Webapplikationen'
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Nav,
	                  { vertical: true },
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'Elixir / Phoenix'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'Java / Spring Boot'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'PHP / Laravel'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'Python'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'JavaScript / React'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: '6', lg: '3', className: 'mt-5' },
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'text-uppercase' },
	                  'Webseiten'
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Nav,
	                  { vertical: true },
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'OctoberCMS'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'Wordpress'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'GatsbyJS'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'Bootstrap'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'JQuery'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: '6', lg: '3', className: 'mt-5' },
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'text-uppercase' },
	                  'Datenbanken'
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Nav,
	                  { vertical: true },
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'PostgreSQL'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '#' },
	                      'MySQL'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '#' },
	                      'Oracle'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '#' },
	                      'DynamoDB'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: '6', lg: '3', className: 'mt-5' },
	                _react2.default.createElement(
	                  'h6',
	                  { className: 'text-uppercase' },
	                  'Anwendungssoftware'
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Nav,
	                  { vertical: true },
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'C# / WPF'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '#' },
	                      'Java / JavaFX'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { className: 'pb-7' },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { lg: '9' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'text-uppercase' },
	                  'Cloud-Computing'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'lead pt-4' },
	                  'Mit Amazon Web Services ist es m\xF6glich eine ganze Serverinfrastruktur zu konfigurieren. Um die Software dann m\xF6glichst portabel zu halten werden Docker Container eingesetzt. Und manchmal kommt man auch ganz ohne Server aus - ',
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Serverless'
	                  ),
	                  ' sozusagen.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.Row,
	              null,
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: '6', lg: '4', className: 'mt-5' },
	                _react2.default.createElement(
	                  _reactstrap.Nav,
	                  { vertical: true },
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'CloudFormation'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '#' },
	                      'Elastic Beanstalk'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'Lambda'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'Simple Queue Service'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: '6', lg: '4', className: 'mt-5' },
	                _react2.default.createElement(
	                  _reactstrap.Nav,
	                  { vertical: true },
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'Route 53'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'DynamoDB'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'API Gateway'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'S3'
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Col,
	                { xs: '6', lg: '4', className: 'mt-5' },
	                _react2.default.createElement(
	                  _reactstrap.Nav,
	                  { vertical: true },
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'RDS'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'Cognito'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactstrap.NavItem,
	                    null,
	                    _react2.default.createElement(
	                      _reactstrap.NavLink,
	                      { to: '/' },
	                      'Cloudfront'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'sls-block' },
	      _react2.default.createElement('div', { className: 'bg-image m-6 left-25 d-none d-md-block', style: { backgroundImage: 'url(' + _undraw_choose_80qg2.default + ')', backgroundSize: 'contain' } }),
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { className: 'py-7 justify-content-end align-items-center' },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { md: '8', xl: '9' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Qualit\xE4t durch testgetriebene Entwicklung.'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'lead pt-4' },
	              'Der geschickte Einsatz von automatisierten Softwaretests hilft dabei hochwertige Software zu implementieren und potentielle Fehler fr\xFChzeitig zu beheben. Daher arbeite ich nach dem Vorgehensmodell des Test Driven Developments (TDD) oder testgetriebener Entwicklung. Dadurch findet die Qualit\xE4tssicherung nicht erst am Ende der Entwicklung statt und spart somit Zeit und Kosten.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = LeistungenPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-leistungen-js-5520ec48869daaeaca94.js